import React from 'react';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DownloadIcon from '@mui/icons-material/Download';
import CalculateIcon from '@mui/icons-material/Calculate';
import ShareIcon from '@mui/icons-material/Share';
import { BRAND } from '../../theme/brandTheme';

/**
 * Shared report header actions — Calculate, CSV, copy image, optional share/close
 */
const ReportDetailActions = ({
  onCalculate,
  onExportCsv,
  onCopyImage,
  onShare,
  onClose,
  showShare = false,
  showClose = false,
}) => (
  <Box className="action-buttons" sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
    {showShare && onShare && (
      <Tooltip title="Paylaş">
        <IconButton
          onClick={onShare}
          aria-label="Raporu paylaş"
          sx={{ color: BRAND.purple, border: `1px solid ${BRAND.borderLight}` }}
        >
          <ShareIcon />
        </IconButton>
      </Tooltip>
    )}
    {onCalculate && (
      <Button
        variant="outlined"
        size="small"
        startIcon={<CalculateIcon />}
        onClick={onCalculate}
        sx={{
          color: BRAND.purple,
          borderColor: BRAND.purple,
          fontWeight: 600,
          '&:hover': { bgcolor: BRAND.purple, color: '#fff', borderColor: BRAND.purple },
        }}
      >
        Calculate
      </Button>
    )}
    {onExportCsv && (
      <Tooltip title="CSV indir">
        <IconButton onClick={onExportCsv} aria-label="CSV indir" sx={{ color: BRAND.purple }}>
          <DownloadIcon />
        </IconButton>
      </Tooltip>
    )}
    {onCopyImage && (
      <Tooltip title="Görüntüyü kopyala">
        <IconButton onClick={onCopyImage} aria-label="Görüntüyü kopyala" sx={{ color: BRAND.purple }}>
          <ContentCopyIcon />
        </IconButton>
      </Tooltip>
    )}
    {showClose && onClose && (
      <IconButton
        className="close-btn"
        data-report-copy-hide
        onClick={onClose}
        aria-label="Kapat"
        sx={{
          bgcolor: '#E8E9E9',
          border: '1px solid #DBDBDB',
          borderRadius: 1,
          '&:hover': { bgcolor: '#ddd' },
        }}
      >
        <CloseIcon />
      </IconButton>
    )}
  </Box>
);

export default ReportDetailActions;
